import VConsole from 'vconsole';
import { ENABLE_VCONSOLE } from '@/config/env';

// vconsole 实例
let vConsole: VConsole | null = null;

/**
 * 初始化 vconsole
 * 只在开发环境下启用
 */
export const initVConsole = (): void => {
  // 只在配置启用时启用
  if (!ENABLE_VCONSOLE) {
    console.log('vconsole 已禁用');
    return;
  }

  // 避免重复初始化
  if (vConsole) {
    console.log('vconsole 已经初始化');
    return;
  }

  try {
    vConsole = new VConsole({
      theme: 'light', // 主题：light 或 dark
      defaultPlugins: ['system', 'network', 'element', 'storage'], // 默认插件
      maxLogNumber: 1000, // 最大日志数量
      disableLogScrolling: false, // 是否禁用日志滚动
      onReady: () => {
        console.log('🎉 vconsole 初始化成功');
        console.log('📱 移动端调试工具已启用');
        console.log('🔧 可在右下角点击 vConsole 按钮打开调试面板');
      },
      onClearLog: () => {
        console.log('🧹 vconsole 日志已清除');
      }
    });

    // 添加一些调试信息
    console.log('🚀 开发环境调试工具已启用');
    console.log('📊 当前环境:', import.meta.env.MODE);
    console.log('🌐 当前域名:', window.location.host);
    console.log('📱 用户代理:', navigator.userAgent);

    // 添加自定义调试命令
    (window as any).debug = {
      vconsole: vConsole,
      clearLogs: () => {
        if (vConsole) {
          vConsole.destroy();
          initVConsole();
        }
      },
      show: () => vConsole?.show(),
      hide: () => vConsole?.hide(),
      version: '1.0.0'
    };

    console.log('💡 使用 window.debug 可以控制 vconsole');
  } catch (error) {
    console.error('❌ vconsole 初始化失败:', error);
  }
};

/**
 * 销毁 vconsole
 */
export const destroyVConsole = (): void => {
  if (vConsole) {
    try {
      vConsole.destroy();
      vConsole = null;
      console.log('vconsole 已销毁');
    } catch (error) {
      console.error('vconsole 销毁失败:', error);
    }
  }
};

/**
 * 切换 vconsole 显示状态
 */
export const toggleVConsole = (): void => {
  if (vConsole) {
    try {
      vConsole.show();
    } catch (error) {
      console.error('vconsole 切换失败:', error);
    }
  }
};

/**
 * 检查 vconsole 是否已初始化
 */
export const isVConsoleReady = (): boolean => {
  return vConsole !== null;
};

/**
 * 获取 vconsole 实例
 */
export const getVConsole = (): VConsole | null => {
  return vConsole;
};

// 自动初始化（可选）
if (ENABLE_VCONSOLE) {
  // 延迟初始化，确保页面加载完成
  setTimeout(() => {
    initVConsole();
  }, 1000);
}
